export default "__VITE_ASSET__CsQ$iG6T__"